import React from 'react';
import { ColumnDef } from '@tanstack/react-table';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../components/Common/UI/Accordion';
import MenuIcon from '../../Layout/Menu/MenuIcon';
import Icons from '../../../../components/Common/Icons/Icons';
import DataTable from '../../../../components/Common/UI/DataTable';

export interface IAccordionData<D> {
  id: string;
  label: string;
  data: D[];
  year?: number;
}

interface IAccordionTable<D> {
  data: IAccordionData<D>[];
  tableCol: ColumnDef<D>[];
  handleActive: (index?: number) => void;
  active?: number;
}

function AccordionTable<D>({ data, tableCol, handleActive, active }: IAccordionTable<D>) {
  return (
    <Accordion type="single" collapsible defaultValue="item-1" className="w-full relative">
      {data.map((el, index) => (
        <AccordionItem
          key={el.id}
          value={`item-${el.id}`}
          className="px-[10px] border mb-[20px] bg-white rounded-[10px]"
        >
          <AccordionTrigger
            className="p-0 h-[54px] justify-start gap-[10px]"
            onClick={() => handleActive(active === index ? undefined : index)}
          >
            <MenuIcon
              icon={<Icons.PlusMinusAnimated active={active !== index} />}
              className="w-[35px] h-[35px] [&_svg_path]:fill-secondary-70"
            />
            <div className="text-secondary-80 text-[18px] font-medium">{el.label}</div>
          </AccordionTrigger>
          <AccordionContent>
            <DataTable
              responsive
              variant="guidance2"
              columns={tableCol}
              data={el.data}
              paginationPosition="bottom"
              paginationVariant="guidance"
              initialState={{ pagination: { pageSize: 15 } }}
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

AccordionTable.defaultProps = {
  active: undefined,
};

export default AccordionTable;
